import InvoiceAdditionalDataForm from '@/components/Fiscal/Invoice/InvoiceAdditionalDataForm';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { UpdateInvoiceAdditionalDTO } from '@/core/domain/invoice/invoice/Invoice.types';
import { PageProps } from '@/types/PageProps';
import { Form, Divider } from 'antd';
import { useIntl } from 'react-intl';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { useEffect } from 'react';
import invoiceValidateRoutes from '../../Invoice.validateRoutes';
import { useLocation } from 'react-router-dom';
import InvoiceButtonsRepeated from '../InvoiceButtonsRepeated';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import InvoiceDeleteButton from '@/components/_common/InvoiceDeleteButton';

const InvoiceAdditionalDataPage: React.FC<PageProps> = ({ route }) => {
  const intl = useIntl().formatMessage;

  const {
    instanceForms,
    invoiceId,
    disabled,
    disabledFields,
    handleSubmit,
    isLoading,
    forms,
    invoice: { data: invoice, isLoading: invoiceIsLoading },
  } = useInvoiceFormContext();

  const [form] = Form.useForm<UpdateInvoiceAdditionalDTO>(
    instanceForms.invoiceAditionalData,
  );

  const { pathname } = useLocation();
  const URL = '/' + pathname.split('/').slice(1, -1).join('/');

  useEffect(() => {
    if (invoice && !forms.invoiceAditionalData) {
      form.setFieldsValue({
        commitmentNote: invoice.commitmentNote,
        orderBuy: invoice.orderBuy,
        contract: invoice.contract,
        taxAdditionalData: invoice.taxAdditionalData,
        companyAdditionalData: invoice.companyAdditionalData,
      });
    }
  }, [invoice, forms.invoiceAditionalData]);

  return (
    <DefaultRouteTabs
      baseKey={invoiceId}
      permissions={route.permissions}
      basePath={URL}
      route={invoiceValidateRoutes(route, invoice?.situation)}
      resourceNotFound={!invoice && !invoiceIsLoading}
      extra={
        <SpaceForButton>
          <InvoiceDeleteButton />

          <SaveButton
            block
            onClick={handleSubmit}
            loading={isLoading}
            disabled={disabled || disabledFields}
          >
            {intl({ id: 'invoice.createadditionalData.btn.save' })}
          </SaveButton>
        </SpaceForButton>
      }
    >
      <InvoiceAdditionalDataForm form={form} />

      <Divider />

      <InvoiceButtonsRepeated />
    </DefaultRouteTabs>
  );
};

export default InvoiceAdditionalDataPage;
